<template>
  <well v-if="!silent" :severity="errors.length ? 'warning' : ''">
    <p class="message">
      {{ message }}
    </p>
    <ul v-if="errors.length">
      <li v-for="error in errors">
        {{ error }}
      </li>
    </ul>
  </well>
</template>

<script>
import { authorize } from '@/redirect';

import Well from './elements/Well';

export default {
  components: {
    well: Well,
  },

  props: {
    callback: String,
    state: { type: String, default: '' },
    prompt: { type: String, default: '' },
    payload: { type: String, default: 'query' },
    responsetype: { type: String, default: 'id-token' },
  },

  data() {
    return {
      errors: [],
    };
  },

  // authorize immediately
  mounted() {
    authorize({
      next: this.callback,
      state: this.state,
      silent: this.silent,
      payload: this.payload,
      responsetype: this.responsetype,
      error: (err) => {
        this.errors.push(err);
      },
    });
  },

  computed: {
    silent() {
      return this.prompt === 'none';
    },

    message() {
      return this.errors.length ?
        'Whoops, something went wrong, this is probably not your fault:' :
        `Signing you in to ${this.app}, please wait…`;
    },

    app() {
      const domain = /^https?:\/\/([^/]+)/.exec(this.callback);
      return domain ? domain[1] : this.callback;
    },
  },
};
</script>

<style scoped>
.message {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Authorize.vue